import { isFunction } from '@bbtfe/utils';
import { wrap } from '../bbtNative';
/**
 *@apiDescription getNeighborInfo方法：会客厅项目中获取邻居的信息
 */
export default function getNeighborInfo(value1, value2, callback) {
    wrap(function () {
        if (isFunction(callback)) {
            window.nativeNeighborCallBack = function (res) {
                callback(res);
            };
        }
        if (window.Bridge && window.Bridge.postMessage) {
            window.Bridge.postMessage({
                method: 'getNeighborInfo',
                params: [value1, value2]
            });
            return true;
        }
        if (window.getNeighborInfo && typeof window.getNeighborInfo == 'function') {
            window.getNeighborInfo(value1, value2);
            return true;
        }
        if (window.android && window.android.getNeighborInfo) {
            window.android.getNeighborInfo(value1, value2);
            return true;
        }
        return false;
    });
}
